{
    "coordinates": [
        -7.239643285949413,
        -39.41152046994259
    ],
    "tooltip": "Crato",
    "title": "Crato Formation",
    "country": "Brazil",
    "period": "Cretaceous",
    "alt": "TODO"
}